import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    // Clyde brand colors
    --black: #000000;
    --white: #ffffff;
    --aa-orange: #e07400;
    --aaa-orange: #b35c00;
    --aa-magenta: #d366f4;
    --aaa-magenta: #bd26e3;
    --dark-gray: #757575;
    --medium-gray: #949494;
    --light-gray: #d1d1d1;
    --lightest-gray: #eeeeee;
    --background-gray: #f6f6f4;
  }

  @font-face {
    font-family: 'Volte';
    font-style: normal;
    font-weight: 300;
    src: url('https://clyde-fonts.s3.amazonaws.com/Volte-Light.otf') format('opentype');
  }

  @font-face {
    font-family: 'Volte';
    font-style: normal;
    font-weight: 400;
    src: url('https://clyde-fonts.s3.amazonaws.com/Volte.otf') format('opentype');
  }

  @font-face {
    font-family: 'Volte';
    font-style: normal;
    font-weight: 500;
    src: url('https://clyde-fonts.s3.amazonaws.com/Volte%2BMedium.otf') format('opentype');
  }

  @font-face {
    font-family: 'Volte';
    font-style: normal;
    font-weight: 600;
    src: url('https://clyde-fonts.s3.amazonaws.com/Volte-Semibold.otf') format('opentype');
  }

  :root {
    --default-font-family: Volte, sans-serif;
    --font-family: var(--custom-font-family, var(--default-font-family, sans-serif));
  }
`;
